import gql from 'graphql-tag';
import {
  suratFragment
} from './surat';

const suratMasukFragment = gql `
  fragment suratMasukFragment on SuratMasuk {
    id
    pengirim
    surat {
      id
      uuid
      pengguna_id
      disposisi_terakhir_pengguna_id
      kode_register
      index
      perihal
      lampiran
      isi_ringkas
      keterangan
      kode_surat_id
      kategori_surat_id
      sifat_surat_id
      tanggal
      kecepatan_surat_id
      nomor_surat {
        id
        surat_id
        nomor
      }
    }
    tipe
  }
`;

const CREATE = gql `
  mutation Create($input: SuratMasuk_CreateInput!) {
    suratMasukCreate(input: $input) {
      id
      pengirim
      surat {
        ...suratFragment
      }
    }
  }
  ${suratFragment}
`;

const GET_ONE = gql `
  query GetOne($where: SuratMasukGetOneWhereWhereConditions) {
    suratMasukGetOne(where: $where) {
      ...suratMasukFragment
    }
  }
  ${suratMasukFragment}
`;

const UPDATE = gql `
  mutation Update($id: ID!, $input: SuratMasuk_UpdateInput!) {
    suratMasukUpdate(id: $id, input: $input) {
      ...suratMasukFragment
    }
  }
  ${suratMasukFragment}
`;

export {
  CREATE,
  GET_ONE,
  UPDATE
};
